import React, {useState} from 'react';
import useImageUrl from '../Controller/useImageUrl.controller';
import {IProps} from '../Config/ImageUrl.types';
import DropDownBtn from '../../DropDownBtn/View/DropDownBtn.view';
import {ResponsiveImg, ImageContainer, DeleteImage, CircularProgressDisable, DisableContainerAutoClasses, DisableTitleAutoClasses, DisableContainerRandom, DisableTitleRandom, CustomAlert, CustomInfoIcon} from '../Style/ImageUrl.style';
import {DeleteContainer, DeleteStyledIcon, DisableBox, DisableBoxAutoClasses, Eye, HoverBox, IconsContainer} from '../../NewClassImages/Style/NewClassImages.style';
import {ApprovalIcon, ApprovalIconContainer, ApprovedBox, WaitForApprovalIconContainer} from '../../ManualRefinementImageList/Style/ManualRefinementImageList.style';
import {Box, Skeleton, Snackbar} from '../../../ui-library';
import {default_square_box_sizes_sizes} from '../../ManualRefinementImageList/Config/ManualRefinementImageList.constants';
import { FLOW } from '../../../pages/RandomSampler/Config/RandomSampler.constants';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import BeforeExitModalView from '../../BeforeExitModal/View/BeforeExitModal.view';
import {CustomTooltip} from '../../AutoStartTrainingModal/Style/AutoStartTrainingModal.style';
import utilService from '../../../services/utilService';
import {DISABLED_IMAGE_MAX_LEN, TOOLTIP_OFFSET} from '../Config/ImageUrl.constants';

// eslint-disable-next-line complexity
const ImageUrl = ({
    img,
    isLoadImageOutSide = true,
    onMouseOver = null,
    width = default_square_box_sizes_sizes,
    height = default_square_box_sizes_sizes,
    getIsClicked = null,
    isAspectRatio = false,
    isCleanClick = false,
    bgcolor = null,
    imageIndex = null,
    manualRefinementState = null,
    setApproved = null,
    fromManual = false,
    fromreferenceinmr = false,
    removeChosenClass = null,
    isHover = false,
    onMouseLeave = null,
    setOpen = null,
    setCurrentImageIndex = null,
    isChoseAnotherClass = false,
    isMoveMode = false,
    disableDelete = null,
    isGlobalLoading = false,
    flow = '',
    onDeleteFile = () => {}
}:IProps) => {
    const [notificationOpen, setNotificationOpen] = useState(false);
    const {imageRef, isLoaded, onClick, isClicked, handleEyeClick, handleCloseNotification} = useImageUrl(img.url, getIsClicked, isCleanClick, setOpen, setCurrentImageIndex, setNotificationOpen, img.approved, flow);
    const manualRefienmentPage = fromManual || fromreferenceinmr;
    const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);
    const {originalStr, isSliced, shortStr} = utilService.normalizedStingWithReturn(img.disableTitle, DISABLED_IMAGE_MAX_LEN, imageRef);

    // @ts-ignore
    return (
        <>
            <BeforeExitModalView
                title={_SYSTEM_TITLES.WhatsInTheDataDeleteSubClusterTitle}
                content={_SYSTEM_TITLES.WhatsInTheDataDeleteSubClusterContent}
                yesTitle={_SYSTEM_TITLES.WhatsInTheDataDeleteSubClusterConfirmBtn}
                cancelTitle={_SYSTEM_TITLES.WhatsInTheDataDeleteSubClusterCancelBtn}
                open={isOpenDeleteDialog}
                setOpen={setIsOpenDeleteDialog}
                onClick={() => {
                    if (imageIndex !== null) {
                        onDeleteFile(manualRefinementState?.manualImages[imageIndex]);
                    }
                    setIsOpenDeleteDialog(false);
                    setNotificationOpen(true);
                }}/>

            <Snackbar
                open={notificationOpen}
                autoHideDuration={2000}
                onClose={handleCloseNotification}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <CustomAlert onClose={handleCloseNotification} severity='info' icon={<CustomInfoIcon />}>
                    cluster has been deleted successfully
                </CustomAlert>
            </Snackbar>
            <ImageContainer
                overflow={fromreferenceinmr ? 'hidden' : 'visible'}
                onMouseOver = {manualRefienmentPage ? onMouseOver : null}
                onMouseLeave={manualRefienmentPage ? onMouseLeave : null}
                width={width}
                height={height}
                sx={{
                    backgroundColor: manualRefienmentPage ? '#1F2937' : null
                }}>
                {(!isLoaded || 'isLoadFromOutSide' in img && img.isLoadFromOutSide) && <Skeleton
                    variant='rectangular'
                    width='100%'
                    height='100%'
                    sx={{ backgroundColor: bgcolor, zIndex: 100000000, borderRadius: '10px'}}
                />}
                {isLoadImageOutSide &&
                    !isMoveMode && <ResponsiveImg
                    isAspectRatio={isAspectRatio}
                    isLoaded={isLoaded}
                    ref={imageRef}
                    id={`img_class_${img.title}`}
                    alt={isLoaded ? img.title : ''}
                    onMouseEnter={(e) => onMouseOver && onMouseOver(e, img)}
                    loading='lazy'/>}
                {isClicked &&
                    <ApprovedBox
                        flow={flow}>
                        <ApprovalIconContainer >
                            <ApprovalIcon fontSize='large' onClick={() => !isGlobalLoading && onClick()} />
                        </ApprovalIconContainer>
                    </ApprovedBox>
                }
                {'disable' in img && img.disable && <>
                    {'disableTitle' in img && (
                        flow === FLOW.autoClasses ? (
                            <DisableBoxAutoClasses>
                                <DisableContainerAutoClasses >
                                    {('isSendToDelete' in img && img.isSendToDelete) ? (
                                        <CircularProgressDisable color='info' />
                                    ) : (<>
                                        {isSliced ? (
                                            <CustomTooltip title={originalStr} placement='top'
                                                PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, TOOLTIP_OFFSET] } }] }}>
                                                <Box>
                                                    <DisableTitleAutoClasses>{shortStr}</DisableTitleAutoClasses>
                                                </Box>
                                            </CustomTooltip>
                                        ) : (
                                            <DisableTitleAutoClasses>{originalStr}</DisableTitleAutoClasses>
                                        )}
                                    </>
                                    )}
                                </DisableContainerAutoClasses>
                            </DisableBoxAutoClasses>
                        ) : (
                            <DisableBox>
                                <DisableContainerRandom>
                                    {('isSendToDelete' in img && img.isSendToDelete) ? (
                                        <CircularProgressDisable color='info' />
                                    ) : (
                                        <>
                                            <DisableTitleRandom>{img.disableTitle}</DisableTitleRandom>
                                            <DeleteImage
                                                id='img_hover_delete'
                                                onClick={() => !isGlobalLoading && disableDelete && disableDelete(imageIndex)}
                                            />
                                        </>
                                    )}
                                </DisableContainerRandom>
                            </DisableBox>
                        )
                    )}
                </>
                }
                {!isClicked && isLoaded && isHover && !img.disable &&
                    <HoverBox onDoubleClick={flow === FLOW.autoClasses ? () => handleEyeClick(imageIndex) : undefined}>
                        {flow !== FLOW.autoClasses
                            ? <IconsContainer >
                                <Eye onClick={() => handleEyeClick(imageIndex)}/>
                                {isChoseAnotherClass && fromManual && manualRefinementState &&
                                'classes' in manualRefinementState && manualRefinementState.classes.length > 1 &&
                                <DropDownBtn
                                    imageIndex={imageIndex}
                                    manualRefinementState={manualRefinementState}
                                    setApproved={setApproved}
                                    removeChosenClass={removeChosenClass}
                                /> }     </IconsContainer> : <DeleteContainer>
                                <DeleteStyledIcon onClick= {() => {
                                    if (imageIndex !== null) {
                                        setIsOpenDeleteDialog(true);
                                    }
                                }}
                                />
                            </DeleteContainer>
                        }
                        {fromManual &&
                        <ApprovedBox >
                            {!isGlobalLoading &&
                                <>
                                    {isClicked && !isChoseAnotherClass && <ApprovalIconContainer > <ApprovalIcon fontSize='large' onClick={onClick}/> </ApprovalIconContainer>}
                                    {!isClicked && !isChoseAnotherClass && <WaitForApprovalIconContainer onClick={onClick} />}
                                </>}
                        </ApprovedBox>}
                    </HoverBox>
                }
            </ImageContainer>
        </>);
};

export default ImageUrl;
